/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MarketingConsentDto } from '../../models/marketing-consent-dto';
import { UpdateMarketingConsentDto } from '../../models/update-marketing-consent-dto';

export interface MarketingConsentControllerUpdateV1$Params {
  id: string;
      body: UpdateMarketingConsentDto
}

export function marketingConsentControllerUpdateV1(http: HttpClient, rootUrl: string, params: MarketingConsentControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<MarketingConsentDto>> {
  const rb = new RequestBuilder(rootUrl, marketingConsentControllerUpdateV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MarketingConsentDto>;
    })
  );
}

marketingConsentControllerUpdateV1.PATH = '/api/v1/marketing-consent/{id}';
